import Link from 'next/link'
import Image from 'next/image'

const FiltersButton = () => {
  return (
    <button
      className={`ml-2 flex items-center font-semibold w-[111px] justify-evenly max-[768px]:w-[51px] max-[768px]:min-w-[51px] h-[32px] !rounded-[10px] shadow-[0_1px_2px_rgba(0,0,0,0.25)] focus:border-none focus:outline-none max-[768px]:h-[41px] italic text-[15px] max-[768px]:text-lg/6
                  bg-white text-[#767676] hover:bg-feYellow hover:text-black `}
    >
      <Link
        href={'/advancedSearch?query='}
        className="pt-[1px] flex flex-row justify-center items-center w-full h-full gap-2"
      >
        <Image
          alt={'filter_icon'}
          width={15}
          height={15}
          className="h-[15px] w-[15]"
          src={`/images/favicons/filter.svg`}
        />
        <span className="max-[768px]:hidden">FILTERS</span>
      </Link>
    </button>
  )
}

export default FiltersButton
